import { ContainerProps } from '../../interfaces/container.interface'
import styles from './MainContainer.module.scss'

const MainContainerComponent = ({ children }: ContainerProps) => {
    return (
        <div className={styles.content}>
            {children}
        </div>
    )
}

export default MainContainerComponent
